import { Branding, BrandingDisabledIf, DisabledPrompt, useModel, useRoute } from "bcms-react";
import Util from "classes/Util";
import { SVGAsset } from 'res';
import { MobileNavItem, MobileNavMenuItem, MobileNavDropdownMenuItem, MobileNavSubDropdownMenuItem } from "../..";

/**
 * @function BID126MobileNavItems
 * @extends React.Component
 * @exported true
 * @description The main component for navigation for BID 126 in mobile.
 * @example
   <BID126MobileNavItems links={{
    profile: profileItem,
    settings: settingsItem
   }}/>
 */
export default function BID126MobileNavItems(props) {
    const { demos, branding } = useModel();
    const navigate = useRoute();
    const paymentsLabel = "Bill Pay";
    const items = props.items ?? {};

    const openAccount = evt => {
        if(Util.inMabi) {
            window.parent.postMessage({ message:"force-global-route", detail: {
                route: `/content/orig`
            }   
            }, "*");
        } else {
            let origVersion = branding.options.orig_version_abi22;
            if(origVersion !== "ORIG19") origVersion = "ORIG20";
            window.open(demos[origVersion], "_blank");
        }
    }

    const onCardsClick = evt => {
    if(Util.inMabi) {
        Util.openABI22StandaloneOverlayInMABI23();
        } else {
        navigate("/ch21");
        }
    }

    const newAccountsItem = <MobileNavDropdownMenuItem className="accounts-mobile-link" itemIcon={<SVGAsset id="ListIcon" />} label="Accounts" dataPoint="Nav_Accounts">
                                <MobileNavMenuItem className="account-summary-mobile-link" to="/accountSummary" label="Account Summary" dataPoint="Nav_Account_Summary" />      
                                <DisabledPrompt>
                                    <MobileNavMenuItem className="account-summary-mobile-link" to="/accountSummary" label="Order Checks" dataPoint="Nav_Order_Checks" />
                                </DisabledPrompt>
                                <DisabledPrompt>
                                    <MobileNavMenuItem className="credit-cards-link" label="Credit Cards" dataPoint="Nav_Credit_Cards" />
                                </DisabledPrompt>
                                <MobileNavMenuItem className="stop-payments-mobile-link" to="/stopPayment" label="Stop Payment" dataPoint="Nav_Stop_Payments" />
                                <>{ !Util.inMabi && <MobileNavMenuItem className="download-transaction-history-link" label="Quicken/Quickbooks" to="/download" dataPoint="Nav_Download" />}</>

                            </MobileNavDropdownMenuItem>;

    const payTransferItem = <>{ Util.inMabi &&  <MobileNavItem className="pay-transfer-mobile-link" label="Pay & Transfer"  dataPoint="Nav_Pay_Transfer" to="/menuPage/payTransfer" />}</>

    const paymentsItem = <MobileNavDropdownMenuItem className="payments-mobile-link" itemIcon={ <SVGAsset id="CircleDollarSignIcon" /> } label="Payments" dataPoint="Nav_Payments">
  
                            <MobileNavMenuItem className="pay-bills-mobile-link" to="/rxpmw" label="Pay Bills" dataPoint="Nav_Pay_Bills" />
                            <MobileNavSubDropdownMenuItem label="Pay my Loan" dataPoint="Nav_Pay_Loan">
                              <MobileNavMenuItem className="transfers-mobile-link" to="/transfers" label="From my Park Account" dataPoint="Nav_Transfers" />
                              <MobileNavMenuItem className="from-another-bank-mobile-link" to="/externalTransfers" label="From another Bank" dataPoint="Nav_Transfer_External_Accounts" />
                            </MobileNavSubDropdownMenuItem>
                            <MobileNavMenuItem className="pay-people-with-zelle-mobile-link" to="/rxpmw" label="Pay People with Zelle" dataPoint="Nav_Pay_People_With_Zelle" />
                        </MobileNavDropdownMenuItem>;

    const transfersItem = <MobileNavDropdownMenuItem className="transfer-mobile-link"  itemIcon={<SVGAsset id="TransfersIcon" />}label="Transfers" dataPoint="Nav_Transfers">
                            <MobileNavSubDropdownMenuItem label="Make A Transfer" dataPoint="Nav_Make_Transfer">
                              <MobileNavMenuItem className="my-accounts-mobile-link" to="/transfers" label="My Accounts" dataPoint="Nav_My_Accounts" />
                              <MobileNavMenuItem className="bank-to-bank-bank-mobile-link" to="/externalTransfers" label="Bank to Bank" dataPoint="Nav_Bank_To_Bank" />
                            </MobileNavSubDropdownMenuItem>
                            <MobileNavSubDropdownMenuItem label="Set up & manage transfers" dataPoint="Nav_Manage_Transfers">
                              <MobileNavMenuItem className="scheduled-transfers-mobile-link" to="/transferActivity/scheduledTransfers" label="Scheduled Transfers" dataPoint="Nav_Transfer_Activity" />
                              <MobileNavMenuItem className="transfer-history-mobile-link" to="/transferActivity/scheduledTransfers" label="Transfer History" dataPoint="Nav_Transfer_History" />
                              <MobileNavMenuItem className="set-up-bank-to-bank-mobile-link" to="/externalTransfers" label="Set up Bank to Bank" dataPoint="Nav_Set_Up_Bank_To_Bank" />
                              <MobileNavMenuItem className="set-up-park-transfer-mobile-link" to="/unlinkedTransferAccounts" label="Set up Park Transfer" dataPoint="Nav_Transfer_Accounts" />
                            </MobileNavSubDropdownMenuItem>
                        </MobileNavDropdownMenuItem>;

const statementsItem = <MobileNavDropdownMenuItem className="transfer-mobile-link" label="Statements" itemIcon={ <SVGAsset id="DocumentIcon" /> } dataPoint="Nav_Statements">
                            <MobileNavMenuItem className="my-accounts-mobile-link" to="/statements" label="View Statements" dataPoint="Nav_eStatements_Notices" />
                            <MobileNavMenuItem className="bank-to-bank-bank-mobile-link" to="/statementPreference" label="Go Paperless" dataPoint="Nav_ePeference" />
                        </MobileNavDropdownMenuItem>;
                    
const toolsItem = <MobileNavDropdownMenuItem className="transfer-mobile-link"  itemIcon={ <SVGAsset id="PiggyBankDollarSignIcon" /> }label="Tools" dataPoint="Nav_Statements">
                    <MobileNavMenuItem className="my-accounts-mobile-link" to="/creditScore" label="Credit Sense" dataPoint="Nav_Credit_Sense" />
                    <MobileNavMenuItem className="bank-to-bank-bank-mobile-link" to="/myFinances" label="Financial Manager" dataPoint="Nav_My_Finances" />
                </MobileNavDropdownMenuItem>;

    const depositItems = <>{Util.inMabi &&
        <MobileNavDropdownMenuItem className="deposits-mobile-link" itemIcon={<SVGAsset id="CameraIcon" />} label="Deposits" dataPoint="Nav_Deposits">
            <MobileNavMenuItem to="/depositACheckWorkflow" label="Deposit a Check" dataPoint="Nav_Deposit_A_Check" />
        </MobileNavDropdownMenuItem>
    }</>

const debitCardsItem = <MobileNavItem className="debit-cards-mobile-link" itemIcon={ <SVGAsset id="CardIcon" /> } label="Debit Cards" to="/ch21" dataPoint="Nav_Cards" />

const alertsItem = <MobileNavDropdownMenuItem className="alerts-mobile-link" label="Alerts" itemIcon={ <SVGAsset id="BellIcon" /> } dataPoint="Nav_Statements">
                    <DisabledPrompt>
                        <MobileNavMenuItem className="account-activity-mobile-link" label="Account Activity" dataPoint="Nav_Account_Activity" />
                    </DisabledPrompt>
                    <DisabledPrompt>
                        <MobileNavMenuItem className="debit-card-and-message-mobile-link" label="Debit Card and Message" dataPoint="Nav_Debit_Card_And_Message" />
                    </DisabledPrompt>
                </MobileNavDropdownMenuItem>;

const moreItem = <MobileNavDropdownMenuItem className="more-mobile-link" label="More" itemIcon={ <SVGAsset id="EllipsisIcon" /> } dataPoint="Nav_More">
                    <DisabledPrompt>
                        <MobileNavMenuItem className="open-an-account-mobile-link" label="Open an Account" dataPoint="Nav_Open_An_Account" />
                    </DisabledPrompt>
                    <DisabledPrompt>
                        <MobileNavMenuItem className="apply-for-a-home-loan-mobile-link" label="Apply for a Home Loan" dataPoint="Nav_Apply_For_A_Home_Loan" />
                    </DisabledPrompt>
                    <DisabledPrompt>
                        <MobileNavMenuItem className="book-an-appointment-mobile-link" label="Book an Appointment" dataPoint="Nav_Book_An_Appointment" />
                    </DisabledPrompt>
                    <DisabledPrompt>
                        <MobileNavMenuItem className="get-park-direct-mobile-link" label="Get ParkDirect" dataPoint="Nav_Get_ParkDirect" />
                    </DisabledPrompt>
                </MobileNavDropdownMenuItem>;

const profileItem = <MobileNavDropdownMenuItem className="profile-mobile-link" itemIcon={ <SVGAsset id="SquareProfileIcon" /> } label="Profile" dataPoint="Nav_Profile">
                        <MobileNavSubDropdownMenuItem label="Change Profile" dataPoint="Nav_Change_Profile">
                            <MobileNavMenuItem className="scheduled-transfers-mobile-link" to="/password" label="Password" dataPoint="Nav_Password" />
                            <MobileNavMenuItem className="phone-mobile-link" to="/phoneNumber" label="Phone" dataPoint="Nav_Phone" />
                            <DisabledPrompt>
                                <MobileNavMenuItem className="security-mobile-link" label="Security Questions" dataPoint="Nav_Security" />
                            </DisabledPrompt>
                            <MobileNavMenuItem className="email-mobile-link" to="/email" label="Email" dataPoint="Nav_Email" />
                            <MobileNavMenuItem className="user-id-mobile-link" label="User ID" to="/userId" dataPoint="Nav_User_ID" />
                        </MobileNavSubDropdownMenuItem>
                        <MobileNavMenuItem className="face-touch-id-mobile-link" to="/authorizedDevicesWorkflow" label="Face/Touch ID" dataPoint="Nav_Authorized_Devices" />
                        <MobileNavMenuItem className="stopped-numbers-mobile-link" to="/stoppedNumbers" label="Stopped Numbers" dataPoint="Nav_Stopped_Numbers" />
                        <MobileNavMenuItem className="text-banking-mobile-link" to="/textBanking" label="Text Banking" dataPoint="Nav_Text_Banking" />
                        <MobileNavMenuItem className="fast-balances-mobile-link" to="/settingsFastBalancesWorkflow" label="Fast Balances" dataPoint="Nav_Fast_Balances" />
                        <MobileNavMenuItem className="user-activity-mobile-link" to="/userActivityWorkflow" label="User Activity" dataPoint="Nav_User_Activity" />
                        <MobileNavMenuItem className="secure-forms-mobile-link" to="/secureForms" label="Secure Forms" dataPoint="Nav_Secure_Forms" />
                        {
                            Util.inMabi &&
                            <MobileNavMenuItem className="authorized-device-enrollment-mobile-link" to="/authorizedDeviceEnrollmentWorkflow" label="Device Enrollment" dataPoint="Utility_Authorized_Device_Enrollment" />
                        }
                        {
                            Util.inMabi &&
                            <DisabledPrompt>
                                <MobileNavMenuItem className="delete-an-account-mobile-link" label="Delete an Account" dataPoint="Utility_Delete_Account" />
                            </DisabledPrompt>
                        }
                        <MobileNavMenuItem className="accepted-disclosures-mobile-link" to="/acceptedDisclosuresWorkflow" label="Accepted Disclosures" dataPoint="Nav_Accepted_Disclosures" />

                    </MobileNavDropdownMenuItem>;

const messagesItem = <MobileNavItem className="messages-mobile-link" to="/messages" label="Messages" itemIcon={<SVGAsset id="EnvelopeIcon" />} dataPoint="Nav_Messages">
<div className="set-width alert-bubble flex-container all-center">
    <span>3</span>
</div>
</MobileNavItem>;

    const contactUsItem = <>{Util.inMabi && <MobileNavDropdownMenuItem className="contact-us-mobile-link" label="Contact Us" itemIcon={<SVGAsset id="QuestionMarkMessageIcon" />} dataPoint="Nav_Contact_Us">
                                            <DisabledPrompt>
                                                <MobileNavMenuItem className="open-an-account-mobile-link" label="Call" dataPoint="Nav_Call" />
                                            </DisabledPrompt>
                                        </MobileNavDropdownMenuItem>}</>;

const chatItem = <DisabledPrompt>
                    <MobileNavItem className="chat-mobile-link" label="Chat" itemIcon={<SVGAsset id="ChatIcon" />} dataPoint="Nav_Chat" />
                </DisabledPrompt>;

const locationsItem = <DisabledPrompt>
                        <MobileNavItem className="locations-mobile-link" itemIcon={ <SVGAsset id="LocationPinIcon" /> } label="Locations" dataPoint="Nav_Locations" />
                    </DisabledPrompt>;

// commented out just in case it gets put back in.
// const helpItem = <DisabledPrompt>
//                     <MobileNavItem className="help-mobile-link" label="Help" itemIcon={ <SVGAsset id="QuestionMarkCircleIcon" /> } dataPoint="Nav_Help" />
//                 </DisabledPrompt>;
   

  return (
   <Branding id="bid_abi22" value="126" >
          { newAccountsItem }
          { payTransferItem }
          { paymentsItem }
          { transfersItem }
          { statementsItem }
          { toolsItem }
          { depositItems }
          { debitCardsItem }
          { alertsItem }
          { moreItem }
          { profileItem }
          { messagesItem }
          { contactUsItem }
          { chatItem }
          { locationsItem }
     </Branding>
  );
}

